import RegularPagesHeader from "../header/RegularPagesHeader";
import Footer from "../footer/Footer";

const MainLayout = ({ children }) => {
  //TODO: hook it up to user status
  // const [bannerVisible, setBannerVisible] = useState(false);

  return (
    <>
      <RegularPagesHeader />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default MainLayout;
